// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"container-queries_wrapper__nq7eH"};